import React from 'react';
import { Phone } from 'lucide-react';

export default function FloatingCallButtons() {
  return (
    <div className="fixed bottom-6 right-4 z-50 flex flex-col gap-2" data-testid="floating-call-buttons">
      {/* Jacob - Lawn Care */}
      <a
        href="tel:0421441364"
        className="flex items-center gap-2 bg-green-900 hover:bg-green-800 text-white px-3 py-2 sm:px-4 sm:py-3 rounded-full shadow-lg transition-all hover:scale-105 hover:shadow-xl group"
        data-testid="call-jacob-btn"
      >
        <div className="bg-white/20 p-1.5 sm:p-2 rounded-full">
          <Phone size={16} className="sm:w-5 sm:h-5" />
        </div>
        <div className="pr-1 sm:pr-2 hidden sm:block">
          <p className="font-oswald font-semibold text-sm">Lawn Care</p>
          <p className="font-inter text-xs text-white/80">Chris</p>
        </div>
        <span className="sm:hidden font-oswald text-xs">Chris</span>
      </a>

      {/* Ryan - Exterior Cleaning */}
      <a
        href="tel:0401226517"
        className="flex items-center gap-2 bg-amber-600 hover:bg-amber-500 text-white px-3 py-2 sm:px-4 sm:py-3 rounded-full shadow-lg transition-all hover:scale-105 hover:shadow-xl group"
        data-testid="call-ryan-btn"
      >
        <div className="bg-white/20 p-1.5 sm:p-2 rounded-full">
          <Phone size={16} className="sm:w-5 sm:h-5" />
        </div>
        <div className="pr-1 sm:pr-2 hidden sm:block">
          <p className="font-oswald font-semibold text-sm">Exterior Cleaning</p>
          <p className="font-inter text-xs text-white/80">Ryan</p>
        </div>
        <span className="sm:hidden font-oswald text-xs">Ryan</span>
      </a>
    </div>
  );
}
